<template>
  <div class="SolutionDetailPage Pt75">
    <div class="box">
      <div class="page-container">

        <!-- PC 端侧边栏 -->
        <aside class="sidebar" v-if="!isMobile">
          <div v-for="category in solutionCategories" :key="category.id" class="sidebar-block">
            <h3 @click="toggleSolution(category.id)" class="solution-title">
              {{ category.name }}
              <span :class="['arrow', { expanded: activeSolutionId === category.id }]">›</span>
            </h3>
            <ul v-show="activeSolutionId === category.id">
              <li v-for="scenario in activeScenarios" :key="scenario.id">
                <a
                    href="#"
                    :class="{ active: currentScenario && currentScenario.id === scenario.id }"
                    @click.prevent="selectScenario(scenario)"
                >
                  {{ scenario.title }}
                </a>
              </li>
            </ul>
          </div>
        </aside>

        <!-- 移动端 Tab 结构 -->
        <main class="main-content" v-if="currentScenario">
          <div class="content-header">
            <div class="header-left">
              <nav aria-label="breadcrumb" class="breadcrumbs">
                <router-link to="/">首页</router-link>
                <span class="divider">/</span>
                <router-link to="/solutions">解决方案</router-link>
                <span class="divider">/</span>
                <span>{{ currentScenario.title }}</span>
              </nav>
              <h2 class="category-title">{{ currentScenario.title }}</h2>
            </div>
          </div>

          <div class="scenario-details-wrapper">
            <div class="content-section">
              <h3 class="section-title">场景问题</h3>
              <div class="section-content" v-html="currentScenario.problem_description_html"></div>
            </div>

            <div class="content-section">
              <h3 class="section-title">除湿解决方案</h3>
              <div class="section-content solution-layout">
                <div class="text-content" v-html="currentScenario.solution_description_html"></div>
                <div class="image-content" v-if="currentScenario.solution_image_path">
                  <img :src="currentScenario.image_img2" alt="解决方案设备图" />
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  </div>
</template>

<script>
import { getCaseCategory, getCaseScenario } from '@/api/request.js';

export default {
  name: 'ScenarioDetailPage',
  props: ['scenarioId'],
  data() {
    return {
      solutionCategories: [],
      scenarios: [],
      currentScenario: null,
      activeSolutionId: null,
      isMobile: false,
      VUE_APP_IMAGE_URL: process.env.VUE_APP_IMAGE_URL,
    };
  },
  computed: {
    activeScenarios() {
      const activeCategory = this.solutionCategories.find(cat => cat.id === this.activeSolutionId);
      return activeCategory ? this.scenarios[this.activeSolutionId] || [] : [];
    },
  },
  methods: {
    async fetchCategoriesAndCurrentScenario() {
      try {
        // Fetch all categories
        const categoryResponse = await getCaseCategory();
        this.solutionCategories = categoryResponse.list;

        // Fetch the current scenario
        const scenarioResponse = await getCaseScenario({ id: this.scenarioId });
        if (scenarioResponse.list.length > 0) {
          this.currentScenario = scenarioResponse.list[0];
          this.activeSolutionId = this.currentScenario.category_id;
          this.fetchScenariosForCategory(this.activeSolutionId);
        } else {
          // Handle case where scenario is not found
          console.error(`Scenario with id ${this.scenarioId} not found.`);
        }

      } catch (error) {
        console.error('Error fetching data:', error);
      }
    },
    async fetchScenariosForCategory(categoryId) {
      if (!this.scenarios[categoryId]) {
        try {
          const response = await getCaseScenario({ category_id: categoryId });
          this.scenarios[categoryId] = response.list;
        } catch (error) {
          console.error(`Error fetching scenarios for category ${categoryId}:`, error);
        }
      }
    },
    selectScenario(scenario) {
      this.$router.push({ name: 'ScenarioDetailPage', params: { scenarioId: scenario.id } });
    },
    toggleSolution(solutionId) {
      if (this.activeSolutionId === solutionId) {
        this.activeSolutionId = null;
      } else {
        this.activeSolutionId = solutionId;
        this.fetchScenariosForCategory(solutionId);
      }
    },
    checkMobile() {
      this.isMobile = window.innerWidth <= 768;
    },
  },
  watch: {
    scenarioId: {
      immediate: true,
      handler() {
        this.fetchCategoriesAndCurrentScenario();
      }
    }
  },
  created() {
    this.checkMobile();
    window.addEventListener('resize', this.checkMobile);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.checkMobile);
  },
};
</script>

<style scoped>
.Pt75 {
  padding-top: 75px;
  padding-bottom: 75px;
  background-color: #f8f9fa;
}
.box {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 16px;
}
.page-container {
  display: flex;
  gap: 30px;
  align-items: flex-start;
}
.sidebar {
  width: 240px;
  flex-shrink: 0;
}
.sidebar-block {
  background-color: #fff;
  border-radius: 8px;
  margin-bottom: 20px;
  box-shadow: 0 5px 15px rgba(0,0,0,0.05);
  overflow: hidden;
}
.sidebar-block ul {
  list-style: none;
  padding: 0;
  margin: 0;
  border-top: 1px solid #f0f0f0;
}
.sidebar-block li a {
  display: block;
  padding: 12px 20px 12px 30px;
  font-size: 15px;
  color: #333;
  text-decoration: none;
  transition: all 0.2s ease-in-out;
  border-left: 3px solid transparent;
}
.sidebar-block li a:hover {
  background-color: #f0f8f4;
  color: #47975a;
  border-left-color: #47975a;
}
.sidebar-block li a.active {
  background-color: #e6f1e9;
  color: #47975a;
  border-left-color: #47975a;
  font-weight: 600;
}
.solution-title {
  font-size: 16px;
  font-weight: 600;
  color: #fff;
  background-color: #47975a;
  padding: 12px 20px;
  margin: 0;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: background-color 0.2s;
}
.solution-title:hover {
  background-color: #3e8651;
}
.solution-title .arrow {
  font-size: 20px;
  font-weight: bold;
  transition: transform 0.3s ease;
}
.solution-title .arrow.expanded {
  transform: rotate(90deg);
}
.tab-container {
  display: none; /* 默认隐藏，移动端显示 */
}
.main-content {
  flex-grow: 1;
  width: 100%;
}
.content-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  background-color: #fff;
  padding: 20px 25px;
  border-radius: 12px;
  margin-bottom: 30px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.05);
  border: 1px solid #e9ecef;
}
.header-left { flex-grow: 1; }
.breadcrumbs { margin-bottom: 8px; font-size: 14px; }
.breadcrumbs a { color: #6c757d; text-decoration: none; transition: color 0.2s; }
.breadcrumbs a:hover { color: #47975a; }
.breadcrumbs span { color: #343a40; font-weight: 500; }
.breadcrumbs .divider { margin: 0 8px; color: #ced4da; }
.category-title { font-size: 26px; color: #333; margin: 0; font-weight: 700; }
.scenario-details-wrapper {
  background-color: #fff;
  padding: 30px 40px;
  border-radius: 12px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.05);
  border: 1px solid #e9ecef;
}
.content-section {
  margin-bottom: 40px;
}
.content-section:last-child {
  margin-bottom: 0;
}
.section-title {
  font-size: 22px;
  color: #333;
  font-weight: 600;
  padding-bottom: 15px;
  margin-bottom: 25px;
  border-bottom: 2px solid #47975a;
  display: inline-block;
}
.section-content {
  color: #555;
  font-size: 16px;
  line-height: 1.8;
}
.section-content p {
  margin-bottom: 1em;
}
.case-logos {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 25px;
  align-items: center;
}
.logo-item {
  border: 1px solid #e9ecef;
  border-radius: 8px;
  padding: 20px;
  text-align: center;
  transition: box-shadow 0.3s ease;
}
.logo-item:hover {
  box-shadow: 0 8px 25px rgba(0,0,0,0.08);
}
.logo-item img {
  max-width: 150px;
  height: 60px;
  object-fit: contain;
  margin-bottom: 15px;
}
.logo-item p {
  margin: 0;
  font-size: 14px;
  color: #666;
}
.solution-layout {
  display: flex;
  gap: 30px;
  align-items: flex-start;
}
.solution-layout .text-content {
  flex: 1;
}
.solution-layout .image-content {
  flex-shrink: 0;
  width: 300px;
}
.solution-layout .image-content img {
  width: 100%;
  border-radius: 8px;
  border: 1px solid #e9ecef;
}
@media (max-width: 992px) {
  .page-container {
    flex-direction: column;
  }
  .sidebar {
    width: 100%;
  }
}
@media (max-width: 768px) {
  .solution-layout {
    flex-direction: column;
  }
  .solution-layout .image-content {
    width: 100%;
    max-width: 350px;
    margin: 20px auto 0;
  }
  .scenario-details-wrapper {
    padding: 20px;
  }
}
</style>